import React, { useState} from 'react';
import './MultiChangeDepartament.scss';
import {Popover, Tooltip} from "antd";
import {
    ArrowLeftIcon,
    ChainIcon,
    CloseStrokeIcon, PlayBoxIcon,
    PlusNewIcon,
    ShevronMenuIcon, VideoMenuIcon
} from "../../../../image";
import {useTranslation} from "react-i18next";
import Text from "../../../../modules/Text/Text";
import {Button} from "../../../../modules/Button";
import {Accordion, Form, useAccordionButton} from "react-bootstrap";
import {hasPermission} from "../../../../utils/helperFunctions";
import {ApiStatus, ROLE_ITEMS} from "../../../../utils/constants";
import {CheckBox} from "../../../../modules/CheckBox";
import ChainBlock from "../../../../modules/Channel/ManageChannels/components/ChainBlock";
import {useDispatch, useSelector} from "react-redux";
import {GetVideosService, MassActionsChannelVideosService} from "../../../../redux/actions";
import {FILTER_SORT_PAGE_TYPES, getValueFilters} from "../../../../modules/Filters/helpers";
import ChannelsModal from "../../../../shared/modals/channelModal/ChannelsModal";
import {VIDEOS_CONSTS} from "../../../../redux/constants";


const MultiChangeDepartament = ({videoIds, page,changeSelectedIds}) => {
    const {t} = useTranslation();
    const [openPopup, setOpenPopup] = useState(false);
    const channels = useSelector(state => state.channels?.channels || []);
    const sortChannels = channels.sort((item) => item?.is_private ? -1 : 1);
    const tagColors = ['#4F40F7', '#2877D4', '#F7404B', '#CB43C6', '#CB7443'];
    const [activeTabs, setActiveTabs] = React.useState([]);
    const [checkedChannels, setCheckedChannels] = useState(null);
    const [checkedChain, setCheckedChains] = useState([]);
    const [open, setOpen] = useState();
    const dispatch = useDispatch();
    const allFilters = useSelector(state => state.filtersOrSort);
    const allFiltersValue = getValueFilters(allFilters,FILTER_SORT_PAGE_TYPES.MANAGED_VIDEOS);
    const [showChannelModal, setShowChannelModal] = useState(false);

    const selectAllChains = (isChecked, channel) => {
        let channelsObj = {
            ...checkedChannels,
            [channel?.id]: {
                id: channel?.id,
                is_bound: isChecked
            }
        }

        if(!isChecked){
            const findChannel = channels.find((item) => item.id === channel?.id)
            const chainsToChannel = (findChannel?.chains || []).map((item) => item?.id);
            const filterChains = checkedChain.map((item)=> {
                if(chainsToChannel.includes(item?.id)){
                    return {
                        id: item?.id,
                        is_bound: false
                    }
                }
                return  item
            })
            setCheckedChains(filterChains)
        }
        setCheckedChannels(channelsObj)
    }

    const deleteSelectedChains = (chainsId) => {
        const arr = checkedChain.map((item) => {
            if(item.id === chainsId) {
                return {
                    ...item,
                    is_bound: false
                }
            }
            return item
        });
        setCheckedChains(arr)
    }

    function CustomToggle({children, eventKey}) {
        const handleClickToggle = () => {
            if(activeTabs.includes(eventKey)) {
                setActiveTabs(activeTabs.filter(item => item !== eventKey));
            } else {
                setActiveTabs([...activeTabs, eventKey]);
            }
        }
        const decoratedOnClick = useAccordionButton(eventKey, handleClickToggle);

        return (
            <ArrowLeftIcon
                className="channel-block__container--arrow"
                onClick={decoratedOnClick}
            />
        );
    }
    const handleOpenChange = (value, id) => {
        setOpen({
            ...open,
            [id]: value
        });
    };
    function handleOpenPopupChange(newOpen) {
        setOpenPopup(newOpen);
    }

    const handleCancelClick = () => {
        setOpenPopup(false);
    }
    const getChannelObj = () => {
        return Object.keys(checkedChannels || {}).map((key)=> {
            const chains = channels.find((item) => item.id === Number(key))?.chains || [];
            const ids = chains.map((item) => item.id);

            return {
                id: Number(key),
                chain_ids: checkedChain.filter((chain) => ids.includes(chain.id)).map((chain) => chain.id)
            }
        })
    }

    const handleApplyClick = async () => {
        try {
            dispatch({
                type: VIDEOS_CONSTS.CHANGE_API_STATUS_GET_VIDEOS,
                payload: ApiStatus.LOADING
            })
            setOpenPopup(false);
            await dispatch(MassActionsChannelVideosService({
                video_ids: videoIds,
                channel_ids: getChannelObj()
            }));
            setCheckedChannels(null);
            setCheckedChains([]);
            setOpenPopup(false);
            changeSelectedIds([])
            await dispatch(GetVideosService({limit: 20, offset: (page - 1) * 20, manage: true, ...allFiltersValue}));
            dispatch({
                type: VIDEOS_CONSTS.CHANGE_API_STATUS_GET_VIDEOS,
                payload: ApiStatus.SUCCESS
            })
        } catch (error) {
            console.log(error);
            dispatch({
                type: VIDEOS_CONSTS.CHANGE_API_STATUS_GET_VIDEOS,
                payload: ApiStatus.ERROR
            })
        }
    }

    const renderAccordionChannel = ({data, index,checkedChain}) => {
        const checkIsChannel = checkedChannels?.[data?.id]?.is_bound;
        const channelChains = (data.chains || []).map((item) => item.id);
        return (
            <Accordion
                className={`${activeTabs.includes(index) ? 'active' : ''}`}
                activeKey={activeTabs}
                style={{
                    '--chain_bg': data?.is_private ? 'rgba(26, 187, 120, 0.10)'
                        : tagColors[index >= 5 ? index % 5 : index] + '14',
                    '--chain_color': data?.is_private ? "#1ABB78" : tagColors[index >= 5 ? index % 5 : index],
                    paddingBottom: data?.is_private ? '12px' : '0',
                }}
            >
                <Accordion.Item
                    eventKey={index}
                    style={{
                        borderBottom: data?.is_private ? '0.7px solid #E6E6E6' : 'none',
                    }}
                >
                    <div className={`channel-block`}>
                        <div className="channel-block__container">
                            <CheckBox
                                type={'checkbox'}
                                onChange={(e) => selectAllChains(e?.target?.checked, data)}
                                checked={checkIsChannel}
                            />
                            {(data?.name || '').length > 38 ?
                                <Tooltip
                                    title={data?.name}
                                    placement="top"
                                >
                                    <div className={`channel-block__container--badge`}>
                                        {data?.name}
                                    </div>
                                </Tooltip>
                                :
                                <div className={`channel-block__container--badge`}>
                                    {data?.name}
                                </div>
                            }
                            {(hasPermission(ROLE_ITEMS.FOREIGN_VIDEO_CHAINS_FULL_ACCESS) || data?.is_private) &&
                                <CustomToggle eventKey={index} className="channel-block__container--arrow"/>}

                        </div>
                        {(!activeTabs.includes(index) && checkedChain.filter((chain) => channelChains.includes(chain.id)).length) ?
                            <div className="channel-block__chains">
                                {checkedChain
                                    .filter((chain) => channelChains.includes(chain.id))
                                    .filter((chain) => chain.is_bound)
                                    .map((item, index) => {
                                        const chainInfo = data.chains.find((chain) => chain.id === item.id);

                                        return (
                                            <>
                                                {(item?.name || '').length > 34 ?
                                                    <Tooltip
                                                        title={chainInfo?.name}
                                                        placement="top"
                                                    >
                                                        <div className="channel-block__chains--item" key={index}>
                                                            <ChainIcon/>
                                                            <span>{chainInfo?.name}</span>
                                                            {(hasPermission(ROLE_ITEMS.FOREIGN_VIDEO_CHAINS_FULL_ACCESS) || data?.is_private) &&
                                                                <CloseStrokeIcon onClick={() => deleteSelectedChains(chainInfo?.id)}/>}
                                                        </div>
                                                    </Tooltip>
                                                    :
                                                    <div className="channel-block__chains--item" key={index}>
                                                        <ChainIcon/>
                                                        <span>{chainInfo?.name}</span>
                                                        {(hasPermission(ROLE_ITEMS.FOREIGN_VIDEO_CHAINS_FULL_ACCESS) || data?.is_private) &&
                                                            <CloseStrokeIcon onClick={() => deleteSelectedChains(chainInfo?.id)}/>}
                                                    </div>
                                                }
                                            </>
                                        )
                                    })}
                            </div>
                            : null}
                    </div>
                    <Accordion.Body>
                        <ChainBlock
                            checkedChannels={checkedChannels}
                            setCheckedChannels={setCheckedChannels}
                            channel={data} checkedChain={checkedChain} setCheckedChains={setCheckedChains}
                            isDepartment
                        />
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        )
    }


    return (
        <>
        <Popover
            arrow={false}
            trigger='click'
            placement="bottomLeft"
            overlayClassName='multi-link'
            onOpenChange={handleOpenPopupChange}
            open={openPopup}
            content={
                <div className="multi-link__container">
                    <div className="multi-link__header">
                        <Text font="bold" size="f20">{t('manage_depatments')}</Text>
                    </div>
                    <div className="multi-link__body">
                        <div className="multi-link__auto-chains-channels">
                            {hasPermission(ROLE_ITEMS.CHANNELS_CREATE) &&
                                <Button
                                    variant="ghost"
                                    text={t('create_department')}
                                    leftIcon={<PlusNewIcon/>}
                                    size="xs"
                                    className="multi-link__auto-chains-channels--btn"
                                    onClick={()=>setShowChannelModal(true)}

                                />
                            }
                            <div className="custom-scroll" style={{overflow: 'auto', maxHeight: '400px'}}>
                                <div className="auto-chains-channels__content">
                                    {sortChannels?.filter((item) => !item.is_private).map((data, index) => (
                                        renderAccordionChannel({data, index,checkedChain})
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="filter-links__footer">
                        <Button
                            text={t('button_cancel')}
                            variant="secondary"
                            size="xs"
                            onClick={handleCancelClick}
                        />
                        <Button
                            text={t('apply')}
                            variant="primary"
                            size="xs"
                            onClick={handleApplyClick}
                        />
                    </div>
                </div>
            }
        >
            <div className={`multi-link__label`}>
                <div className={`multi-link__wrap`}>
                    <VideoMenuIcon className="multi-link--chain-icon"/>
                    <Text font="book" size="f14" color="#1ABB78">{t('manage_depatments')}</Text>
                    <ShevronMenuIcon className={`multi-link__label--arrow ${open ? 'open' : ''}`}/>
                </div>
            </div>
        </Popover>
    {showChannelModal && <ChannelsModal showModal={showChannelModal}
                                        createChannel={true}
                                        onHide={() => setShowChannelModal(false)}/>}
        </>
    );
};

export default MultiChangeDepartament;